import { MegaphoneIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Trumpet = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <MegaphoneIcon size={Sizes[size]} mirrored {...rest} fill={fill} />;
};

Trumpet.displayName = 'Trumpet';
